function lastDayOfMonth(y, m) {
  return new Date(y, m + 1, 0).getDate();
}

function normalizeStartDay(startDay) {
  const n = Math.floor(Number(startDay));
  if (!Number.isFinite(n) || n < 1) return 1;
  if (n > 31) return 31;
  return n;
}

function collectAnchors(today, startDay) {
  const anchors = [];
  const baseYear = today.getFullYear();
  for (let y = baseYear - 1; y <= baseYear + 1; y++) {
    for (let m = 0; m < 12; m++) {
      const last = lastDayOfMonth(y, m);
      const prevDate = new Date(y, m, 0);
      const prevLast = lastDayOfMonth(prevDate.getFullYear(), prevDate.getMonth());
      if (startDay <= last) {
        anchors.push(new Date(y, m, startDay));
        if (startDay > prevLast && startDay !== 1) {
          anchors.push(new Date(y, m, 1));
        }
      }
    }
  }
  return anchors.sort((a, b) => a - b);
}

export function getSalaryPeriod(today, startDay, offset = 0) {
  const d = normalizeStartDay(startDay);
  const anchors = collectAnchors(today, d);
  let currentIdx = -1;
  for (let i = 0; i < anchors.length; i++) {
    if (anchors[i] <= today) currentIdx = i;
    else break;
  }
  const idx = currentIdx + offset;
  if (idx < 0 || idx >= anchors.length) return null;
  const from = anchors[idx];
  const next = anchors[idx + 1];
  const to = next ? new Date(next.getFullYear(), next.getMonth(), next.getDate() - 1) : null;
  return { from, to };
}

export function getCurrentSalaryPeriod(today, startDay) {
  return getSalaryPeriod(today, startDay, 0);
}

/** Work period (Verktímabil) — always the full calendar month, independent of the salary period start day. */
export function getWorkPeriod(today, offset = 0) {
  const from = new Date(today.getFullYear(), today.getMonth() + offset, 1);
  const to = new Date(today.getFullYear(), today.getMonth() + offset + 1, 0);
  return { from, to };
}

export function getPreviousSalaryPeriod(today, startDay) {
  return getSalaryPeriod(today, startDay, -1);
}

// `locale` is a locale string, or a function (date) => short month name from the app's
// translations (see utils/dateNames.js) for languages the browser has no Intl data for.
function monthFormatter(locale) {
  if (typeof locale === "function") return (d) => locale(d).toLowerCase().replace(".", "");
  const loc = unwrapLocale(locale);
  return (d) => d.toLocaleDateString(loc, { month: "short" }).toLowerCase().replace(".", "");
}

function unwrapLocale(loc) {
  if (typeof loc === "string") return loc;
  if (loc && typeof loc.value === "string") return loc.value;
  return "en-US";
}

export function formatSalaryPeriodLabel(period, locale) {
  if (!period || !period.from || !period.to) return "";
  const fmtMonth = monthFormatter(locale);
  return `${period.from.getDate()}.${fmtMonth(period.from)} - ${period.to.getDate()}.${fmtMonth(period.to)}`;
}

export function formatWeekRangeLabel(today, locale) {
  const fmtMonth = monthFormatter(locale);
  const mon = new Date(today);
  mon.setDate(today.getDate() - ((today.getDay() + 6) % 7));
  const sun = new Date(mon);
  sun.setDate(mon.getDate() + 6);
  return `${mon.getDate()}.${fmtMonth(mon)} - ${sun.getDate()}.${fmtMonth(sun)}`;
}

export function getWeekRange(today) {
  const mon = new Date(today);
  mon.setDate(today.getDate() - ((today.getDay() + 6) % 7));
  const sun = new Date(mon);
  sun.setDate(mon.getDate() + 6);
  return { from: mon, to: sun };
}

export function dateStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
